import { render } from "./agencySlide1.vue?vue&type=template&id=72da470a"
import script from "./agencySlide1.vue?vue&type=script&lang=js"
export * from "./agencySlide1.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__